import { render } from "./ReturnCustDocLine.vue?vue&type=template&id=60b80859&scoped=true"
import script from "./ReturnCustDocLine.vue?vue&type=script&lang=js"
export * from "./ReturnCustDocLine.vue?vue&type=script&lang=js"

import "./ReturnCustDocLine.vue?vue&type=style&index=0&id=60b80859&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b80859"]])

export default __exports__